import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import {
    NAVIGATION_MAP_PROVIDER,
    NavigationLinkType,
    NavigationMapProvider,
    NavigationNode,
    NavigationSection,
    SessionService
} from '@edl-development/edl-common';
import { StateService } from '@uirouter/angular';
import { Subscription } from 'rxjs';

@Component({
    selector: 'edl-authenticated-navigation',
    templateUrl: './edl-authenticated-navigation.component.html',
    styleUrls: ['./edl-authenticated-navigation.component.scss']
})
export class EdlAuthenticatedNavigationComponent implements OnInit, OnDestroy {
    navigationNodes: NavigationNode[] = [];
    collapsedState: Record<string, boolean> = {};
    minMenu: boolean = false;
    isMobileView: boolean = false;

    private _navigationToggle?: Subscription;

    constructor(
        public stateService: StateService,
        public sessionService: SessionService,
        @Inject(NAVIGATION_MAP_PROVIDER) private navigationMapProvider: NavigationMapProvider
    ) { }

    ngOnInit() {
        this.navigationNodes = this.navigationMapProvider.getNavigationMap({
            section: NavigationSection.Sidebar
        });

        for (const node of this.navigationNodes) {
            if (node.children?.length) {
                this.collapsedState[node.id] = !this.isActive(node);
            }
        }

        this._navigationToggle = this.sessionService.navigationToggle.subscribe((value: boolean) => {
            this.minMenu = value;
        });

        this.checkMobileView();
        window.addEventListener('resize', () => this.checkMobileView());
    }

    ngOnDestroy() {
        this._navigationToggle?.unsubscribe();
        window.removeEventListener('resize', () => this.checkMobileView());
    }

    toggleCollapse(nodeId: string): void {
        if (this.minMenu && !this.isMobileView) {
            this.sessionService.toggleMenu();
        }

        const isCurrentlyCollapsed = this.collapsedState[nodeId];

       if (isCurrentlyCollapsed) {
            this.collapseAllSubmenus();
        }

        // Toggle the clicked submenu
        this.collapsedState[nodeId] = !this.collapsedState[nodeId];
    }

    isActive(node: NavigationNode): boolean {
        if (node.isActive) {
            return node.isActive(this.stateService);
        }

        if (node.activeStateRoot && this.stateService.includes(node.activeStateRoot)) {
            return true;
        }

        if (node.link?.type === NavigationLinkType.State) {
            return this.stateService.includes(node.link.uiSref);
        }

        if (node.children?.length) {
            return node.children.some(child => this.isActive(child));
        }

        return false;
    }

    collapseAllSubmenus(): void {
        Object.keys(this.collapsedState).forEach(key => {
            this.collapsedState[key] = true;
        });
    }

    toggleMenu() {
        this.sessionService.toggleMenu();
    }

    private checkMobileView(): void {
        this.isMobileView = window.innerWidth < 992;
    }
}
